export default "__VITE_ASSET__6a282fb0__"